<script>
import { onMount } from 'svelte'
import { createEventDispatcher } from "svelte";
    
const dispatch = createEventDispatcher();

onMount(async () => {
  
});

export let backgroundColor = "#2c3e50"
export let w = 0
export let h = 0
export let color = "#fff"
export let n = 0
export let title = ""

const _handleClickEvent = () => {
    dispatch("click")
}

</script>

<div 
    class="circular d-flex justify-content-center align-items-center"
    style="background-color:{backgroundColor};left:{w+5}px;top:{h/2-45*n}px;color:{color}"
    title={title}
    on:click={_handleClickEvent}
>
    <slot></slot>
</div>

<style>
    .circular {
        position: absolute;
        height: 40px;
        width: 40px;
        border-radius: 50%;
        background-color: tomato;
        color : #fff;
        cursor: pointer;
        transition: all 250ms;
    }

    .circular:hover {
        transform: scale(1.2);
    }
</style>